import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import Ic_Order from "../../../../assets/images/mi_reorder-alt.png";
import { getGridColumnClass } from "../../../../utils/fileUtils";
import { EditableComponent } from "../EditableComponent/EditableComponent";
import { FieldRenderer } from "../FieldRenderer/FieldRenderer";
interface SortableSubStepFieldProps {
  field: any;
  isEditable: boolean;
  currentStepData: any;
  currentSubStepData: any;
}

const SortableSubStepField: React.FC<SortableSubStepFieldProps> = ({
  field,
  isEditable,
  currentStepData,
  currentSubStepData,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `substep-field-${field.Id}`,
    disabled: !isEditable,
  });

  const methods = useFormContext();
  const name = `id_${currentStepData.Id}.InverseParentSteps.id_${currentSubStepData?.Id}.StepFields.field_${field.Id}.IsVisible`;

  const isVisible = methods.watch(name);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // opacity: isDragging ? 0.5 : 1,
    opacity: isVisible || !isEditable ? "100%" : "30%",
  };

  const { type } = useParams();
  const isViewTemplate = type === "details";
 
  return (
   (field?.IsVisible || isEditable) ?<div
      key={field.Id}
      ref={setNodeRef}
      style={style}
      {...(isEditable ? attributes : {})}
      {...(isEditable ? listeners : {})}
      className={`h-fit ${isEditable ? "cursor-move" : ""} ${getGridColumnClass(field?.ColumnSize || 0)} max-lg:!col-span-2`}
    >
      {isEditable ? (
        <div className="flex items-center gap-4">
          <img className="h-5 w-5" alt="" src={Ic_Order} />
          <EditableComponent
            name={name}
            component={<FieldRenderer field={field} />}
            field={field}
          />
        </div>
      ) : (
        field?.IsVisible && (
          <FieldRenderer disabled={isViewTemplate} field={field} />
        )
      )}
    </div> :<></>
  );
};

export default SortableSubStepField;
